enum Action {
  CLOSE_CHAT = 'closeChat',
  OPEN_CHAT = 'openChat',
  SET_HAS_NEW_CHAT_MESSAGE = 'setHasNewChatMessage',
}

export default Action;
